import axios from 'axios';
import TokenService from './token.service';

const redeemClient = axios.create({
  baseURL: process.env.REACT_APP_ACCOUNTS_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

redeemClient.interceptors.request.use((config) => {
  const token = TokenService.getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class RedeemService {
  async previewCoupon(code) {
    const response = await redeemClient.get('/accounts/activate/preview', {
      params: { code },
    });
    return response.data;
  }

  async activateCoupon({ email, code, company_name, channel, integration_id }) {
    const response = await redeemClient.post('/accounts/activate', {
      email,
      code,
      company_name,
      channel: channel || null,
      integration_id: integration_id || null,
    });
    return response.data;
  }

  async updateChannel({ account_id, workflow_id, channel, integration_id }) {
    const response = await redeemClient.patch(`/accounts/${account_id}/channel`, {
      channel,
      workflow_id,
      integration_id: integration_id || null,
    });
    return response.data;
  }

  async verifyEmailToken(token) {
    const response = await redeemClient.post('/accounts/verify-email', { token });
    return response.data;
  }

  async resendVerification({ email, company_name, code }) {
    const response = await redeemClient.post('/accounts/verify-email/resend', {
      email, company_name, code,
    });
    return response.data;
  }
}

export default new RedeemService();
